module.exports = __webpack_public_path__ + "img/cover-remix.4d5a3afa.jpg";